/* PattePlanet : fiche produit (galerie, variantes, quantité, barre d'achat mobile). Vanilla, sans dépendance. */
(function () {
  'use strict';
  var PP = window.PP || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__ppProduct) return;
    root.__ppProduct = true;

    var form = root.querySelector('[data-add-to-cart-form]');
    var sectionId = root.getAttribute('data-product-section');
    var productUrl = root.getAttribute('data-product-url');
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var variantsEl = root.querySelector('[data-variants-json]');
    var variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }

    /* ---------- Galerie ---------- */
    var thumbList = root.querySelector('[data-gallery-thumbs]');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var countEl = root.querySelector('[data-gallery-count]');
    var vis = slides.map(function (s, i) { return i; }); /* index des diapos affichées */
    var cur = 0;
    var ready = false; /* pas d'animation au chargement (LCP) */

    function slideIndex(mediaId) {
      return slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
    }
    /* Une couleur = ses photos : de la photo principale de la variante jusqu'à celle de la couleur suivante.
       shortcut: repose sur l'ordre des médias, pas sur une donnée produit; ignoré si les blocs sont irréguliers (2 à 6 photos). */
    var groups = (function () {
      var starts = [];
      variants.forEach(function (v) {
        var i = v.image ? slideIndex(v.image) : -1;
        if (i > -1 && starts.indexOf(i) < 0) starts.push(i);
      });
      starts.sort(function (a, b) { return a - b; });
      if (starts.length < 2) return [];
      starts[0] = 0;
      var g = starts.map(function (st, k) {
        var out = [];
        for (var i = st; i < (k + 1 < starts.length ? starts[k + 1] : slides.length); i++) out.push(i);
        return out;
      });
      return g.every(function (x) { return x.length >= 2 && x.length <= 6; }) ? g : [];
    })();
    /* Tri par couleur d'après le nom de fichier des photos (ex. "...-hoodie-dust-front-..."), valable pour tous les produits.
       Chaque photo va à la couleur dont le nom (slug) est le plus long et présent dans le fichier. */
    function slug(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    var files = slides.map(function (s) {
      var im = s.querySelector('img');
      var src = im ? (im.getAttribute('src') || im.currentSrc || '') : '';
      return '-' + slug(decodeURIComponent(src.split('?')[0].split('/').pop())) + '-';
    });
    var colorMap = (function () {
      var n = variants.length ? variants[0].options.length : 0, best = null;
      for (var oi = 0; oi < n; oi++) {
        var vals = [];
        variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
        if (vals.length < 2) continue;
        var map = {}, hit = 0;
        vals.forEach(function (x) { map[x] = []; });
        files.forEach(function (f, i) {
          var win = null, len = 0;
          vals.forEach(function (x) { var sg = slug(x); if (sg && f.indexOf('-' + sg + '-') > -1 && sg.length > len) { win = x; len = sg.length; } });
          if (win !== null) { map[win].push(i); hit++; }
        });
        if (vals.every(function (x) { return map[x].length > 0; }) && (!best || hit > best.hit)) best = { oi: oi, map: map, hit: hit };
      }
      return best;
    })();
    function groupFor(v) {
      if (colorMap && v) {
        var cv = v.options[colorMap.oi], g0 = colorMap.map[cv];
        if (g0 && g0.length) {
          var cs = '-' + slug(cv) + '-', seen = {}, out = [];
          g0.forEach(function (idx) {
            var f = files[idx], p = f.lastIndexOf(cs);
            var view = p > -1 ? f.slice(p + cs.length).replace(/[a-z0-9]{8,}-(jpg|jpeg|png|webp)-$/, '') : f;
            view = view.replace(/-?\d+-?$/, '').replace(/^-|-$/g, '') || 'x';
            if (seen[view]) return;
            seen[view] = 1; out.push(idx);
          });
          return out.length ? out : g0;
        }
      }
      var i = v && v.image ? slideIndex(v.image) : -1;
      return groups.find(function (g) { return g.indexOf(i) > -1; }) || null;
    }

    function setCurrent(index) {
      cur = index;
      var pos = vis.indexOf(index);
      slides.forEach(function (s, i) { s.classList.toggle('is-current', i === index); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (countEl) countEl.textContent = pos + 1 + ' / ' + vis.length;
      if (prevBtn) prevBtn.disabled = pos <= 0;
      if (nextBtn) nextBtn.disabled = pos >= vis.length - 1;
    }
    function goTo(index) {
      var s = slides[index];
      if (!s || !track) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setCurrent(index);
    }
    function step(d) {
      var pos = Math.max(0, Math.min(vis.length - 1, vis.indexOf(cur) + d));
      goTo(vis[pos]);
    }
    /* Affiche seulement les photos du groupe (null = toutes) et revient à la première. */
    function applyGroup(g) {
      var next = g || slides.map(function (s, i) { return i; });
      var same = next.length === vis.length && next.every(function (x, i) { return x === vis[i]; });
      vis = next;
      slides.forEach(function (s, i) { s.hidden = vis.indexOf(i) < 0; });
      thumbs.forEach(function (t, i) { if (t.parentNode) t.parentNode.hidden = vis.indexOf(i) < 0; });
      var multi = vis.length > 1;
      if (thumbList) thumbList.hidden = !multi;
      [prevBtn, nextBtn, countEl].forEach(function (el) { if (el) el.hidden = !multi; });
      if (track) track.scrollLeft = 0;
      setCurrent(vis[0]);
      if (!same && ready && track && !reduce) {
        track.classList.remove('is-swapping');
        void track.offsetWidth;
        track.classList.add('is-swapping');
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
    if (track && 'IntersectionObserver' in window && slides.length > 1) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) setCurrent(slides.indexOf(en.target));
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    if (track) {
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); step(e.key === 'ArrowRight' ? 1 : -1);
      });
    }
    function showMedia(v) {
      var g = groupFor(v);
      if (g) { applyGroup(g); return; }
      if (vis.length !== slides.length) applyGroup(null);
      var idx = v && v.image ? slideIndex(v.image) : -1;
      if (idx > -1) goTo(idx);
    }
    applyGroup(null);

    /* ---------- Zoom ---------- */
    var zoomDlg = root.parentNode.querySelector('[data-zoom-dialog]') || document.querySelector('[data-zoom-dialog]');
    var zoomImg = zoomDlg ? zoomDlg.querySelector('[data-zoom-img]') : null;
    root.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom-trigger]');
      if (!z || !zoomDlg || !zoomImg || !PP.openDialog) return;
      zoomImg.src = z.getAttribute('data-zoom-src');
      zoomImg.alt = z.getAttribute('data-zoom-alt') || '';
      PP.openDialog(zoomDlg, z);
    });

    if (!form) return;

    /* ---------- Quantité ---------- */
    var qtyInput = form.querySelector('[data-qty-input]');
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]');
      if (!b || !qtyInput) return;
      var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      qtyInput.value = v;
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    });

    /* ---------- Variantes ---------- */
    var idInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]');
    var atcLabel = atc ? atc.querySelector('[data-btn-label]') : null;
    var optionSets = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var sticky = document.querySelector('[data-sticky-bar]');
    var stickyBtn = sticky ? sticky.querySelector('[data-sticky-atc]') : null;
    var stickyLabel = sticky ? sticky.querySelector('[data-sticky-label]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var abort = null;

    function selected() {
      return optionSets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === o; });
      });
    }

    /* Marque comme indisponibles les valeurs sans variante disponible, selon les autres choix. */
    function refreshAvailability() {
      var sel = selected();
      optionSets.forEach(function (fs, i) {
        Array.prototype.forEach.call(fs.querySelectorAll('input'), function (inp) {
          var test = sel.slice(); test[i] = inp.value;
          var match = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return test[k] === o; });
          });
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !match);
        });
        var out = fs.querySelector('[data-option-selected]');
        var c = fs.querySelector('input:checked');
        if (out && c) out.textContent = c.value;
      });
    }

    function setButtons(available) {
      var txtAdd = form.getAttribute('data-label-add');
      var txtOut = form.getAttribute('data-label-out');
      [[atc, atcLabel], [stickyBtn, stickyLabel]].forEach(function (pair) {
        var b = pair[0], l = pair[1];
        if (!b) return;
        b.disabled = !available;
        if (available) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
        if (l) l.textContent = (available ? txtAdd : txtOut) || l.textContent;
      });
    }

    function swapFromSection(variantId) {
      if (abort) abort.abort();
      abort = typeof AbortController === 'function' ? new AbortController() : null;
      var url = productUrl + '?variant=' + variantId + '&section_id=' + encodeURIComponent(sectionId);
      form.closest('[data-product-info]').setAttribute('aria-busy', 'true');
      return fetch(url, { signal: abort ? abort.signal : undefined, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['price', 'status'].forEach(function (k) {
            var src = doc.querySelector('[data-product-dynamic="' + k + '"]');
            var dst = root.querySelector('[data-product-dynamic="' + k + '"]');
            if (src && dst) dst.innerHTML = src.innerHTML;
          });
          if (stickyPrice) {
            var p = root.querySelector('[data-product-dynamic="price"]');
            var cur = p ? p.querySelector('.pp-price__current, .pp-price__now, [data-price-current]') : null;
            stickyPrice.textContent = (cur ? cur.textContent : (p ? p.textContent : '')).replace(/\s+/g, ' ').trim().split(' TTC')[0];
          }
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; })
        .then(function () { var i = form.closest('[data-product-info]'); if (i) i.removeAttribute('aria-busy'); });
    }

    function onChange() {
      refreshAvailability();
      var v = findVariant(selected());
      var err = form.querySelector('[data-form-error]');
      if (err) { err.hidden = true; err.textContent = ''; }
      if (!v) {
        if (idInput) idInput.value = '';
        form.setAttribute('data-unavailable', 'true');
        setButtons(false);
        return;
      }
      idInput.value = v.id;
      form.setAttribute('data-unavailable', v.available ? 'false' : 'true');
      setButtons(v.available);
      showMedia(v);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
      swapFromSection(v.id);
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) onChange();
    });
    refreshAvailability();
    /* Au chargement, ouvre la galerie sur l'image de la variante choisie (?variant= ou 1re disponible). */
    var v0 = findVariant(selected());
    if (v0) showMedia(v0);
    ready = true;

    /* Empêche l'envoi d'une variante indisponible (touche Entrée dans le champ quantité, etc.). */
    form.addEventListener('submit', function (e) {
      var unavailable = form.getAttribute('data-unavailable') === 'true' || !idInput.value || (atc && atc.disabled);
      if (unavailable) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    if (atc && atc.disabled) form.setAttribute('data-unavailable', 'true');

    /* ---------- Barre d'achat fixe (mobile) ---------- */
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var ioBar = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        if (show) sticky.removeAttribute('aria-hidden'); else sticky.setAttribute('aria-hidden', 'true');
        sticky.inert = !show;
      });
      ioBar.observe(atc);
      sticky.setAttribute('aria-hidden', 'true');
      sticky.inert = true;
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-section]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Éditeur de thème : réinitialisation à l'ajout ou au rechargement d'une section. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-product-section]') : null;
    if (el) init(el);
  });
})();
